import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import {AdtaDeviceOverviewContext} from "./context/AdtaDeviceOverviewContext";
import ValidationTabBody from "../../commonui/mheValidation/ValidationTabBody";
import MHEValidationContextProvider from "../../mhevalidation/context/MHEValidationContext";

const AdtaDeviceValidation = ({intl}) => {

    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);
    const deviceList = Object.values(viewModel.adtaDeviceInformation);

    const props = {
        dispatch,
        deviceList,
        intl
    }

    return (<MHEValidationContextProvider><ValidationTabBody {...props}/></MHEValidationContextProvider> );
}

export default injectIntl(AdtaDeviceValidation)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/AdtaDeviceValidation.js